import { NavLink as RouterLink } from 'react-router-dom';
import { cn } from '@/lib/cn';
import type { NavLink } from '@/lib/navigation';

export function NavItem({ item }: { item: NavLink }) {
  const Icon = item.icon;
  return (
    <RouterLink
      to={item.to}
      end={item.to === '/'}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-2.5 rounded-[7px] px-2.5 py-[5.5px] text-[12.5px] transition-colors duration-100',
          isActive
            ? 'bg-primary font-medium text-white shadow-[0_1px_5px_rgba(0,122,255,0.35)]'
            : 'text-text/80 hover:bg-black/[0.045]'
        )
      }
    >
      {({ isActive }) => (
        <>
          <Icon
            className={cn('h-[15px] w-[15px] shrink-0', isActive ? 'text-white' : 'text-text/55')}
            strokeWidth={1.9}
            aria-hidden
          />
          <span className="flex-1 truncate">{item.label}</span>
        </>
      )}
    </RouterLink>
  );
}
